exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".design-system{background-color:#e7e9ee}.design-system h1{font-size:24px;line-height:1;margin-top:30px;margin-bottom:20px}.design-system__demo-wrapper{padding:40px;max-width:1200px;margin:0 auto}.demo__form-row{display:block;margin-bottom:20px}.demo__form-config{display:inline-block;vertical-align:top;min-width:200px}.demo__form-config:not(:last-child){margin-right:20px}.demo__preview{min-width:400px;padding:50px;border:1px dashed currentColor}", ""]);

// exports
